<template>
  <div class="top-nav">
    <div class="nav-button" v-for="(cat, i) in data">
      <button 
        :class="{ active: cat.featured }"
        @click="test(i)">
        {{ cat.cat_title }}
      </button>
    </div>
  </div>

  <div class="sds-wrapper">
    <div class="sds-cat"
      v-for="cat in sortedData()"
      :data-box="cat.box_style"
      :data-featured="cat.featured">
      <h1 class="nTitle">{{ cat.cat_title }}</h1>

      <div class="sds-box-wrapper">
        <template v-for="box in cat.data">
          <a v-if="cat.box_style == 'true'"
            class="sds-box"
            target="_blank"
            :href="box.link"
            tabindex="0">
            <div class="formula" v-html="box.formula"></div>
            <p>{{ box.title }}</p>
          </a>

          <a v-else
            class="sds-link"
            target="_blank"
            :href="box.link">
            <p>{{ box.title }}</p>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.addEventListener('DOMContentLoaded', () => {
      $(this.$el.parentElement.querySelector('.top-nav')).slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    });
  },
  props: {
    data: [],
  },
  methods: {
    sortedData: function() {
      const startData = [];
      const endData = [];

      this.data.forEach((item) => {
        if (item.featured) {
          startData.push(item);
        } else {
          endData.push(item);
        }
      });

      return startData.concat(endData);
    },
    test: function(i) {
      this.data[i].featured = !this.data[i].featured;
      this.$forceUpdate(); // fix
    },
  }
}
</script>
